exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col[data-v-5a6869f3]{padding-top:0 !important}.card-main[data-v-5a6869f3]{padding:0 1rem;margin-top:-0.5rem}.submitActions[data-v-5a6869f3]{padding:1rem;display:flex;justify-content:space-between}.recipients_count[data-v-5a6869f3]{margin-bottom:17px}.progress[data-v-5a6869f3]{margin-top:5px;margin-bottom:20px}", ""]);

// exports
